import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_does_the_fac_prov_ongoing_comm_and_training_to_existing_pro'

export const dataPointDefinition = {
  retracedId: 'how_does_the_fac_prov_ongoing_comm_and_training_to_existing_pro',
  name: 'How does the facility provide on-going communication and training to EXISTING production workers?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'VERBAL_COMMUNICATION',
      text: 'Verbal communication',
      externalIds: [
        {
          id: 'ms-5--8-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WRITTEN_COMMUNICATION_I_E_CURRENT_WORKERS_MIGHT_RECEIVE_WRITTEN',
      text: 'Written communication (i.e. current workers might receive written notification regarding changes to company handbooks)',
      externalIds: [
        {
          id: 'ms-5--8-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'POSTED_COMMUNICATION_I_E_DISPLAY_POSTINGS_AROUND_THE_FACILITY_',
      text: 'Posted communication (i.e. display postings around the facility)',
      externalIds: [
        {
          id: 'ms-5--8-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MULTI_MEDIA_COMMUNICATION_I_E_WORKERS_WATCH_A_VIDEO_ONLINE_LEAR',
      text: 'Multi-media communication (i.e. workers watch a video, online learning, etc.)',
      externalIds: [
        {
          id: 'ms-5--8-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TRAINING_EXISTING_WORKERS_RECEIVE_ON_GOING_TRAININGS_IN_PERSON_',
      text: 'Training - existing workers receive on-going trainings in-person (i.e. classroom trainings, trainings at their work station etc.)',
      externalIds: [
        {
          id: 'ms-5--8-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMMUNICATION_AND_TRAINING_IS_PROVIDED_IN_A_LANGUAGE_UNDERSTOOD',
      text: 'Communication and training is provided in a language understood by workers',
      externalIds: [
        {
          id: 'ms-5--8-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-5--8-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-5--8-7f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'VERBAL_COMMUNICATION',
                'WRITTEN_COMMUNICATION_I_E_CURRENT_WORKERS_MIGHT_RECEIVE_WRITTEN',
                'POSTED_COMMUNICATION_I_E_DISPLAY_POSTINGS_AROUND_THE_FACILITY_',
                'MULTI_MEDIA_COMMUNICATION_I_E_WORKERS_WATCH_A_VIDEO_ONLINE_LEAR',
                'TRAINING_EXISTING_WORKERS_RECEIVE_ON_GOING_TRAININGS_IN_PERSON_',
                'COMMUNICATION_AND_TRAINING_IS_PROVIDED_IN_A_LANGUAGE_UNDERSTOOD',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-do-20',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 22400,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
